import { createRouter, createWebHistory } from 'vue-router';
import type { RouteRecordRaw } from 'vue-router';
import { nextTick } from 'vue';
import HomeView from '@/views/HomeView.vue';
import JoinAsMember from "@/views/JoinAsMember.vue";
import NotFoundComponent from "@/views/NotFoundComponent.vue";
import FinishedApplication from "@/views/FinishedApplication.vue";
import FinishedContractSigning from "@/views/FinishedContractSigning.vue";
import ContractSigning from "@/views/ContractSigning.vue";

const DEFAULT_TITLE = 'so-strom - einfach mitmachen';

/**
 * Application routes
 */
const routes: RouteRecordRaw[] = [
  { // keep the home route at first
    path: '/',
    name: 'HomeView', // "HomeView" is needed in App.vue
    meta: { title: "so-strom - einfach mitmachen" },
    component: HomeView,
  },

  {
    path: '/:ecn([GRC][CD]\\d{6})?',
    name: 'HomeView', // "HomeView" is needed in App.vue
    meta: { title: "so-strom - einfach mitmachen" },
    component: HomeView,
  },

  {
    path: '/join/:ecn([GRC][CD]\\d{6})/:step?',
    name: 'JoinAsMember',
    component: JoinAsMember,
  },

  {
    path: '/finished',
    name: 'FinishedApplication',
    component: FinishedApplication,
  },

  {
    path: '/finishedContractSigning',
    name: 'FinishedContractSigning',
    component: FinishedContractSigning,
  },

  {
    path: '/contractSigning/:uniqueKey',
    name: 'ContractSigning',
    component: ContractSigning,
    meta: { title: 'so-strom - Vertragsunterzeichnung' },
  },

  {
    path: '/:pathMatch(.*)',
    component: NotFoundComponent,
    name: "NotFoundComponent",
    meta: { title: "so-strom - einfach mitmachen" },
  },
];

/**
 * Router instance with history mode
 */
const router = createRouter({
  history: createWebHistory(),
  routes
});

/**
 * Update document title after each route change
 */
router.afterEach((to) => {
  // Use next tick to handle router history correctly
  // see: https://github.com/vuejs/vue-router/issues/914#issuecomment-384477609
  nextTick(() => {
    document.title = to.meta?.title as string || DEFAULT_TITLE;
  });
});

// set initially to the first route
document.title = routes[0].meta?.title as string;

export default router;
